var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackUserIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1418 2.1883C16.8039 1.90356 16.2992 1.94662 16.0145 2.28448C15.7297 2.62234 15.7728 3.12706 16.1106 3.4118C16.9909 4.15365 17.399 5.09316 17.399 6.00019C17.399 6.90721 16.9909 7.84673 16.1106 8.58853C15.7728 8.87334 15.7297 9.37801 16.0145 9.71586C16.2992 10.0537 16.8039 10.0968 17.1418 9.8121C18.3586 8.78654 18.9991 7.4096 18.9991 6.00019C18.9991 4.59077 18.3586 3.21385 17.1418 2.1883Z",
    fill: "#A2C357"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5148 3.55939C15.177 3.27465 14.6723 3.31771 14.3875 3.65557C14.1028 3.99343 14.1459 4.49815 14.4837 4.78289C14.9145 5.146 15.098 5.58915 15.098 5.99979C15.098 6.41043 14.9145 6.85357 14.4837 7.21669C14.1459 7.50143 14.1028 8.00615 14.3875 8.34401C14.6723 8.6819 15.177 8.72494 15.5148 8.44021C16.2823 7.79337 16.6981 6.91283 16.6981 5.99979C16.6981 5.08675 16.2823 4.20621 15.5148 3.55939Z",
    fill: "#A2C357"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.40039 6.00017C5.40039 3.79094 7.19133 2 9.40056 2C11.6098 2 13.4007 3.79094 13.4007 6.00017C13.4007 8.20939 11.6098 10.0003 9.40056 10.0003C7.19133 10.0003 5.40039 8.20939 5.40039 6.00017ZM9.40056 3.60007C8.07502 3.60007 7.00046 4.67463 7.00046 6.00017C7.00046 7.3257 8.07502 8.40027 9.40056 8.40027C10.7261 8.40027 11.8007 7.3257 11.8007 6.00017C11.8007 4.67463 10.7261 3.60007 9.40056 3.60007Z",
    fill: "#A2C357"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40027 12.4004C6.74919 12.4004 4.60007 14.5495 4.60007 17.2006C4.60007 17.6424 4.24188 18.0006 3.80003 18.0006C3.35819 18.0006 3 17.6424 3 17.2006C3 13.6658 5.86549 10.8003 9.40027 10.8003C12.9351 10.8003 15.8005 13.6658 15.8005 17.2006C15.8005 17.6424 15.4424 18.0006 15.0005 18.0006C14.5586 18.0006 14.2005 17.6424 14.2005 17.2006C14.2005 14.5495 12.0513 12.4004 9.40027 12.4004Z",
    fill: "#A2C357"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackUserIcn);
export default __webpack_public_path__ + "static/media/feedback_user_icn.848404869cb7f576218943c4090b31a2.svg";
export { ForwardRef as ReactComponent };